
<template>
  <b-row
    class="md:mr-5 md:ml-5 align-items-center justify-content-center no-gutters"
  >
    <b-col
      class="col-6 col-md-4 col-lg-3 mt-1 mt-md-3 d-flex justify-content-center"
      v-for="(image, imageIndex) in itemsThumbnails"
      :key="imageIndex"
    >
      <div
        @click="handleRouting(image.tag)"
        class="myBlock d-flex justify-content-center align-items-center flex-wrap"
      >
        <b-img :id="imageIndex" class="icon-image" :src="image.src"></b-img>
        <strong class="text-center w-100 text-color-light">{{
          image.name ? image.name : image.tag
        }}</strong>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

export default {
  components: {
    CoolLightBox,
  },
  data() {
    return {
      items: [
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio style?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Architecture-off-white.png",
          tag: "Architecture",
          id: "1",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/leadership-off-white.png",
          tag: "Leadership-Management",
          id: "2",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?o",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Data-off-white.png",
          tag: "Data-Science",
          name: "Data",
          id: "3",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/JVM-off-white.png",
          tag: "JVM",
          id: "4",
        },
        {
          title: "a beautiful mountain view",
          description: "Photo by Facundo",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Devops-off-white.png",
          tag: "DevOps",
          id: "5",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Cloud-off-white.png",
          tag: "Cloud",
          id: "6",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/testing-off-white.png",
          tag: "Quality-Test",
          name: "Quality & Test",
          id: "7",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Web-off-white.png",
          tag: "Web",
          id: "8",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Security-off-white.png",
          tag: "Security",
          id: "9",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/Net-off-white.png",
          tag: "NET",
          name: ".Net",
          id: "10",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/keynote-off-white.png",
          name: "Keynotes & workshops",
          tag: "Keynote",
          id: "kw",
        },
        {
          title: "a beautiful mountain view",
          description:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Totam aut laborum molestias. Facere, enim totam eum accusamus doloremque maiores fuga consectetur natus saepe animi eos necessitatibus hic quos optio id?",
          src: "https://res.cloudinary.com/oredev/image/upload/v1680601761/2023_web/icons%20lp/OFF-track-off-white.png",
          tag: "OFF-Track",
          name: "OFF track",
          id: "11",
        },
      ],
      index: null,
    };
  },
  methods: {
    addToUrl(url, stringToAdd) {
      if (!url) {
        return;
      }
      const array = url.split("upload/");
      array.splice(1, 0, "upload/" + stringToAdd + "/");
      const urlString = array.join("");

      return urlString;
    },
    handleRouting(tag) {
      this.$router.push("sessions?tags=" + tag + "&day=day3");
    },
  },
  computed: {
    itemsThumbnails() {
      return this.items.map((e) => {
        const url = this.addToUrl(e.src, "");
        const obj = {
          title: e.title,
          description: e.description,
          name: e.name,
          src: url,
          tag: e.tag,
        };
        return obj;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.image:hover {
  cursor: pointer;
}

.myBlock {
  padding: 20px;
  background-color: #292929;
  width: 164px;
  height: 204px;
  cursor: pointer;
}
@media screen and (max-width: 1200px) {
  .myBlock {
    width: 142px;
  }
}

.myBlock:hover {
  background-color: #69afab;
}
.overflow-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  line-clamp: 2;
  -webkit-box-orient: vertical;
}

.icon-image {
  margin-left: auto;
  margin-right: auto;
  width: 100px;
  height: 100px;
}

@media screen and (max-width: 767px) {
  .overflow-ellipsis {
    -webkit-line-clamp: 5; /* number of lines to show */
    line-clamp: 5;
  }
  .myBlock {
    width: 108px;
    height: 155px;
  }
  .icon-image {
    width: 77px;
    height: 76px;
  }
  strong {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Gallery.vue